import React, { useEffect, useState } from 'react';
import api from '../api';
import './PageTable.css';

function Products() {
  const [products, setProducts] = useState([]);
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [uploading, setUploading] = useState({});
    const handleFileUpload = async (e, key, galleryIndex = null) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading((u) => ({ ...u, [key]: true }));
    try {
      const formData = new FormData();
      formData.append('photo', file);
      const res = await api.post('/admin-upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (galleryIndex !== null) {
        setForm((f) => {
          const newPhotos = [...f.photos];
          newPhotos[galleryIndex] = res.data.url;
          return { ...f, photos: newPhotos };
        });
      } else {
        setForm((f) => ({ ...f, photo_url: res.data.url }));
      }
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload foto');
    } finally {
      setUploading((u) => ({ ...u, [key]: false }));
      e.target.value = '';
    }
  };

const [form, setForm] = useState({
    name: '', description: '', price: '', stock: 0,
    photo_url: '', status: 'draft', artist_id: '',
    photos: ['', '', '', '', ''],
  });

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin-products/all');
      setProducts(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchArtists = async () => {
    try {
      const res = await api.get('/artists/public?limit=100');
      setArtists(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchArtists();
  }, []);

  const openCreate = () => {
    setForm({ name: '', description: '', price: '', stock: 0, photo_url: '', status: 'draft', artist_id: '', photos: ['', '', '', '', ''] });
    setModal({});
  };

  const openEdit = async (item) => {
    try {
      const res = await api.get(`/admin-products/${item.id}`);
      const existingPhotos = res.data.photos.map((p) => p.photo_url);
      const photosPadded = [...existingPhotos, '', '', '', '', ''].slice(0, 5);
      setForm({
        name: res.data.name,
        description: res.data.description || '',
        price: res.data.price,
        stock: res.data.stock,
        photo_url: res.data.photo_url || '',
        status: res.data.status,
        artist_id: res.data.artist_id || '',
        photos: photosPadded,
      });
      setModal(res.data);
    } catch (err) {
      alert('Gagal memuat detail produk');
    }
  };

  const updatePhoto = (index, value) => {
    const newPhotos = [...form.photos];
    newPhotos[index] = value;
    setForm({ ...form, photos: newPhotos });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      const cleanPhotos = form.photos.filter((p) => p && p.trim());
      const payload = { ...form, artist_id: form.artist_id || null, photos: cleanPhotos };
      if (modal.id) {
        await api.put(`/admin-products/${modal.id}`, payload);
      } else {
        await api.post('/admin-products', payload);
      }
      setModal(null);
      await fetchProducts();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan produk');
    }
  };

  const deleteProduct = async (id) => {
    if (!window.confirm('Hapus produk ini?')) return;
    try {
      await api.delete(`/admin-products/${id}`);
      await fetchProducts();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus produk');
    }
  };

  return (
    <div>
      <div className="page-header-row">
        <h1 className="page-title" style={{ marginBottom: 0 }}>Produk / Merchandise</h1>
        <button className="btn-primary" onClick={openCreate}>+ Tambah Produk</button>
      </div>
      {loading ? (
        <p>Memuat...</p>
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Foto</th>
                <th>Nama</th>
                <th>Artis</th>
                <th>Harga</th>
                <th>Stok</th>
                <th>Status</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p) => (
                <tr key={p.id}>
                  <td>
                    <div style={{ width: 44, height: 44, borderRadius: 4, overflow: 'hidden', background: '#303034' }}>
                      {p.photo_url && (
                        <img src={p.photo_url} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                      )}
                    </div>
                  </td>
                  <td>{p.name}</td>
                  <td>{p.artist_name || '-'}</td>
                  <td>Rp {Number(p.price).toLocaleString('id-ID')}</td>
                  <td>{p.stock}</td>
                  <td><span className={`status-badge status-${p.status === 'published' ? 'approved' : 'pending'}`}>{p.status}</span></td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn-edit" onClick={() => openEdit(p)}>Edit</button>
                      <button className="btn-delete" onClick={() => deleteProduct(p.id)}>Hapus</button>
                    </div>
                  </td>
                </tr>
              ))}
              {products.length === 0 && (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center', color: '#888' }}>
                    Belum ada produk
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <form className="modal-box" onClick={(e) => e.stopPropagation()} onSubmit={submitForm} style={{ maxHeight: '85vh', overflowY: 'auto' }}>
            <h2>{modal.id ? 'Edit Produk' : 'Tambah Produk Baru'}</h2>
            <input
              type="text"
              placeholder="Nama produk"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
            />
            <textarea
              placeholder="Deskripsi"
              rows={3}
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            />
            <input
              type="number"
              placeholder="Harga (Rp)"
              value={form.price}
              onChange={(e) => setForm({ ...form, price: e.target.value })}
              required
            />
            <input
              type="number"
              placeholder="Stok"
              value={form.stock}
              onChange={(e) => setForm({ ...form, stock: e.target.value })}
            />

            <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 12 }}>
              Foto Utama (tampil di card & thumbnail)
            </label>
            <input
              type="url"
              placeholder="URL foto utama"
              value={form.photo_url}
              onChange={(e) => setForm({ ...form, photo_url: e.target.value })}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, marginBottom: 8 }}>
              <label style={{ display: 'inline-block', fontSize: 13, color: '#C9A66B', border: '1px solid #C9A66B', padding: '6px 14px', borderRadius: 6, cursor: 'pointer' }}>
                {uploading.main ? 'Mengupload...' : '📁 Upload dari Perangkat'}
                <input type="file" accept="image/jpeg,image/png,image/webp" onChange={(e) => handleFileUpload(e, 'main')} disabled={uploading.main} style={{ display: 'none' }} />
              </label>
              {form.photo_url && (
                <div style={{ width: 36, height: 36, borderRadius: 4, overflow: 'hidden', background: '#303034' }}>
                  <img src={form.photo_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                </div>
              )}
            </div>

            <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 12 }}>
              Galeri Tambahan (maks 5 total, opsional)
            </label>
            {form.photos.map((url, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 6, alignItems: 'center' }}>
                <input
                  type="url"
                  placeholder={`URL foto ${i + 1}`}
                  value={url}
                  onChange={(e) => updatePhoto(i, e.target.value)}
                  style={{ flex: 1 }}
                />
                <label style={{ display: 'inline-block', fontSize: 12, color: '#C9A66B', border: '1px solid #C9A66B', padding: '5px 10px', borderRadius: 6, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  {uploading[`gallery${i}`] ? '...' : '📁 Upload'}
                  <input type="file" accept="image/jpeg,image/png,image/webp" onChange={(e) => handleFileUpload(e, `gallery${i}`, i)} disabled={uploading[`gallery${i}`]} style={{ display: 'none' }} />
                </label>
                {url && (
                  <div style={{ width: 36, height: 36, borderRadius: 4, overflow: 'hidden', background: '#303034', flexShrink: 0 }}>
                    <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                  </div>
                )}
              </div>
            ))}

            <select value={form.artist_id} onChange={(e) => setForm({ ...form, artist_id: e.target.value })} style={{ marginTop: 8 }}>
              <option value="">-- Tanpa artis spesifik --</option>
              {artists.map((a) => (
                <option key={a.id} value={a.id}>{a.name}</option>
              ))}
            </select>
            <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={() => setModal(null)}>Batal</button>
              <button type="submit" className="btn-primary">Simpan</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default Products;
